var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2308 2.46154C17.2308 3.82101 16.1288 4.92308 14.7693 4.92308C14.3822 4.92308 14.0161 4.83374 13.6902 4.67457L4.77578 12.6976C4.87113 12.96 4.92314 13.2431 4.92314 13.5385C4.92314 14.8979 3.82107 16 2.4616 16C1.10213 16 6.41986e-05 14.8979 6.42581e-05 13.5385C6.43175e-05 12.179 1.10213 11.0769 2.4616 11.0769C2.84866 11.0769 3.21484 11.1663 3.54067 11.3254L12.4551 3.30242C12.3598 3.04005 12.3078 2.75687 12.3078 2.46154C12.3078 1.10207 13.4098 -1.67022e-07 14.7693 -1.07597e-07C16.1288 -4.81729e-08 17.2308 1.10207 17.2308 2.46154Z",
    fill: "#007AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinear);
export default __webpack_public_path__ + "static/media/linear.2bb9c6393abf5fc736867076d8e422b6.svg";
export { ForwardRef as ReactComponent };